const INDICES = [
  {
    icon: 'ri-sun-line',
    title: '日漫专区',
    desc: '最新日漫连载、经典名作合集',
    count: '1.2万部',
    color: 'primary',
  },
  {
    icon: 'ri-moon-line',
    title: '韩漫专区',
    desc: '热门网漫、独家条漫推荐',
    count: '8千部',
    color: 'accent',
  },
  {
    icon: 'ri-flag-2-line',
    title: '国漫专区',
    desc: '国风漫画、原创精品汇聚',
    count: '5千部',
    color: 'secondary',
  },
  {
    icon: 'ri-fire-line',
    title: '热血格斗',
    desc: '燃到爆炸的战斗冒险漫画',
    count: '3千部',
    color: 'primary',
  },
  {
    icon: 'ri-heart-line',
    title: '恋爱甜宠',
    desc: '甜蜜浪漫的心动恋爱故事',
    count: '4千部',
    color: 'accent',
  },
  {
    icon: 'ri-search-eye-line',
    title: '悬疑推理',
    desc: '烧脑刺激的推理探案漫画',
    count: '2千部',
    color: 'secondary',
  },
  {
    icon: 'ri-emotion-laugh-line',
    title: '搞笑日常',
    desc: '轻松欢乐的日常喜剧漫画',
    count: '3千部',
    color: 'primary',
  },
];

const colorMap: Record<string, { bg: string; iconBg: string; iconColor: string; hover: string }> = {
  primary: {
    bg: 'bg-primary-50',
    iconBg: 'bg-primary-100',
    iconColor: 'text-primary-600',
    hover: 'hover:border-primary-200',
  },
  accent: {
    bg: 'bg-accent-50',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-700',
    hover: 'hover:border-accent-200',
  },
  secondary: {
    bg: 'bg-secondary-50',
    iconBg: 'bg-secondary-100',
    iconColor: 'text-secondary-700',
    hover: 'hover:border-secondary-200',
  },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">
            分类索引
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            按分类快速找到你感兴趣的漫画
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
          {INDICES.map((item, idx) => {
            const c = colorMap[item.color];
            return (
              idx < 3 ? (
                <a
                  key={idx}
                  href={`#${item.title}`}
                  className={`group flex items-center gap-4 p-4 md:p-5 rounded-xl border border-background-200/70 bg-background-50 ${c.hover} transition-colors cursor-pointer`}
                >
                  <div className={`w-12 h-12 shrink-0 flex items-center justify-center rounded-lg ${c.iconBg}`}>
                    <i className={`${item.icon} text-xl ${c.iconColor}`}></i>
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-sm font-semibold text-foreground-950 mb-0.5">
                      {item.title}
                    </h3>
                    <p className="text-xs text-foreground-600">{item.desc}</p>
                    <span className="text-[11px] text-foreground-400">{item.count}</span>
                  </div>
                </a>
              ) : (
                <a
                  key={idx}
                  href={`#${item.title}`}
                  className={`group flex items-center gap-4 p-4 md:p-5 rounded-xl border border-background-200/70 bg-background-50 ${c.hover} transition-colors cursor-pointer`}
                >
                  <div className={`w-12 h-12 shrink-0 flex items-center justify-center rounded-lg ${c.iconBg}`}>
                    <i className={`${item.icon} text-xl ${c.iconColor}`}></i>
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-sm font-semibold text-foreground-950 mb-0.5">
                      {item.title}
                    </h3>
                    <p className="text-xs text-foreground-600">{item.desc}</p>
                    <span className="text-[11px] text-foreground-400">{item.count}</span>
                  </div>
                </a>
              )
            );
          })}
        </div>
      </div>
    </section>
  );
}